export class TagDoctors {
    tagDoctorId: number;
    designation: string;
    providerId: number;
    doctorUnitMasterId: number;
    providerName: string;
    amount?: number;
}